import { AppModuleCheckList } from '@/shared/AppModuleCheckList'
import { TemplateItem } from '@/template/interface'
import { Modal } from 'antd'
import React, { Fragment, useEffect, useState } from 'react'
import { BoxContact } from '.'
import { BoxContactModalProps, BoxContactProps } from '../interface'

export const BoxContactModal: React.FC<BoxContactModalProps> = (
  props: BoxContactModalProps
) => {
  const {
    visible,
    boxItems,
    templateItems,
    templateTotal,
    onVisibleChange,
    onContact,
    onChange
  } = props
  const [appModuleVisible, setAppModuleVisible] = useState<boolean>(false)
  const [selectTemplate, setSelectTemplate] = useState<TemplateItem>()
  const [search, setSearch] = useState<{ name?: string; remark?: string }>()
  const contactProps: BoxContactProps = {
    pagination: {
      total: templateTotal,
      onChange: (pageNumber: number, pageSize?: number) => {
        const skip = (pageNumber - 1) * (pageSize || 10)
        onChange?.(skip, search)
      }
    },

    onSearch: (args: any) => {
      setSearch(args)
      onChange?.(0, args)
    }
  }

  useEffect(() => {
    if (!visible && appModuleVisible) {
      setAppModuleVisible(false) // 如果父级模态框关闭，则同步关闭子模态框
    }
  }, [visible])

  return (
    <Fragment>
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        title='关联模板'
        width={800}
        visible={visible}
        onCancel={() => onVisibleChange?.(false)}
        onOk={() => {
          setAppModuleVisible(true)
        }}
      >
        <BoxContact
          {...contactProps}
          data={templateItems}
          size='small'
          onSelect={(items: TemplateItem[]) => {
            if (items.length > 0) {
              setSelectTemplate(items[0])
            } else {
              setSelectTemplate(undefined)
            }
          }}
        />
      </Modal>
      <AppModuleCheckList
        visible={appModuleVisible}
        boxItems={boxItems}
        template={selectTemplate}
        onOk={(items) => {
          if (!boxItems || !selectTemplate || !items || items.length <= 0) {
            return
          }
          onContact?.(boxItems, selectTemplate, items)
        }}
        onCancel={() => setAppModuleVisible(false)}
      />
    </Fragment>
  )
}
